<script lang="ts">
import { onMount } from "svelte";
import type { Link } from "$lib/types";

export let venueLink: Link;

let details: HTMLDetailsElement;

onMount(() => {
	document.addEventListener("click", closeDetails);
});

function closeDetails() {
	if (details) {
		details.open = false;
	}
}

type NavItem =
	| {
			type: "group";
			group: {
				name: string;
				items: Link[];
			};
	  }
	| {
			type: "item";
			item: Link;
	  };

$: items = [
	{
		type: "group",
		group: {
			name: "本養成講座について",
			items: [
				{ text: "Balanced Bodyとは", href: "/about/" },
				{ text: "講師紹介", href: "/master-instructor/" },
				venueLink,
				{ text: "受講生の声", href: "/feedback/" },
				{ text: "フォローアップ", href: "/followup/" },
				{ text: "よくあるご質問", href: "/faq/" },
			],
		},
	},
	{
		type: "item",
		item: { text: "コース", href: "/courses/" },
	},
	{
		type: "item",
		item: { text: "料金", href: "/prices/" },
	},
	{
		type: "item",
		item: { text: "スケジュール", href: "/schedule/" },
	},
] satisfies NavItem[];
</script>

<style>
  ul li {
    color: #4352F5;
  }

  ul li svg {
    fill: #4352F5;
  }

  details[open] summary {
    outline: 2px solid #4352F5;
    background-color: #f6f8fb;
  }

  details[open] summary svg {
    transform: rotate(180deg);
  }
</style>

<nav>
  <ul class="flex items-center gap-x-4">
    {#each items as navItem}
      <li class="relative">
        {#if navItem.type === 'group'}
          <details bind:this={details} class="relative">
            <summary class="cursor-pointer rounded-[10px] p-1" style="list-style: none;" on:click={$e => $e.stopPropagation()}>
              <div class="flex items-center gap-x-1 py-1 px-2">
                <p class="text-action text-sm">
                  {navItem.group.name}
                </p>
                <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16" aria-hidden="true" style="flex-shrink: 0;">
                  <path d="M13 6.33337L8 11.3334L3 6.33337" fill="#FFF" stroke="#4352F5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </div>
            </summary>
            <div class="absolute top-12 bg-white rounded-[10px] shadow-lg shadow-borderGray z-10">
              <ul class="py-2">
                {#each navItem.group.items as { text, href }}
                  <li>
                    <a href={href} on:click={closeDetails} class="block px-6 w-80 hover:underline">
                      <div class="flex items-center justify-between border-b border-solid border-bgGray py-4">
                        <p class="text-sm">
                          {text}
                        </p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 -960 960 960">
                          <path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z" stroke="#4352F5" />
                        </svg>
                      </div>
                    </a>
                  </li>
                {/each}
              </ul>
            </div>
          </details>
        {/if}
        {#if navItem.type === 'item'}
          <a href={navItem.item.href} on:click={closeDetails}>
            <p class="text-action text-sm py-1 px-2">
              {navItem.item.text}
            </p>
          </a>
        {/if}
      </li>
    {/each}
  </ul>
</nav>